import React from "react";
import { useLanguage } from "../contexts/LanguageContext";

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="mag-footer">
      <div className="mag-logo">
        <span className="mag-logo-top" style={{ color: "#fff" }}>
          MAG
        </span>
        <span className="mag-logo-bottom">PROTECTION</span>
      </div>
      <div className="mag-footer-text">{t.footer.text}</div>
    </footer>
  );
};

export default Footer;
